(function () {
    'use strict';

    angular
        .module('emails')
        .controller('ViewReportCampaignController', ViewReportCampaignController);

    ViewReportCampaignController.$inject = ['$uibModalInstance', 'campaign','CampaignsService','$sce','$scope'];

    function ViewReportCampaignController($uibModalInstance, campaign, CampaignsService,$sce,$scope) {
        var vm                = this;
        $scope.trustAsHtml = function(string) {
            return $sce.trustAsHtml(string);
        };
        vm.campaign           = campaign;
        vm.urls               = '';
        vm.ok                 = ok;
        vm.cancel             = cancel;
        vm.getStatisticsUrl   = getStatisticsUrl;

        activate();

        function activate() {
            vm.getStatisticsUrl(vm.campaign.id);
        }

        function getStatisticsUrl(campaign_id) {
            var query = [];
            query['id'] = campaign_id;
            CampaignsService.getStatisticsUrl(query).then(function(response){
                vm.urls = response.data;
            }).catch(function(err) {
            });
        }

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }
    }
})();